import styled from 'styled-components';
import { IoClose } from 'react-icons/io5';

import { outlineGray, subMenuDropdownBackground } from '../../config/colors';
import Button from '../Button';

export const DocumentsWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  background-color: ${subMenuDropdownBackground};
  padding: 40px 25px 95px 42px;
  flex-direction: column;
`;

export const DocList = styled.ul`
  list-style: '*';
  margin: 0;
  padding: 0;
`;

export const DocItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const DocItem = styled.li`
  line-height: 2;
  padding-left: 8px;
  font-size: 0.875rem;

  ::marker {
    font-weight: bold;
  }
`;

export const AddDocWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  flex-direction: column;
  align-items: flex-end;
`;

export const AddDocInput = styled.input`
  width: 100%;
  border: 2px solid ${outlineGray};
  border-radius: 3px;
  padding: 5px 10px;
  font-size: 0.875rem;
  text-align: start;
  resize: none;
  font-family: Verdana, Arial, Helvetica, sans-serif;
`;

export const AddDocBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '120px',
    height: '35px',
    marginTop: '10px'
  },
  textStyle: {},
})``;

export const RemoveItemBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '20px',
    height: '20px',
    marginLeft: '10px',
  },
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'white',
    size: '16px',
  },
})``;